import React from 'react'
import './Event.scss'

import GalleryBlock from './GalleryBlock/GalleryBlock';

import User from '../Assets/home/user.svg'
import Calendar from '../Assets/home/calendar.svg'

import EventImg from '../Assets/home/event.png'

import NTF1 from '../Assets/home/nft1.png'
import NTF2 from '../Assets/home/nft2.png'
import NTF3 from '../Assets/home/nft3.png'
import NTF4 from '../Assets/home/nft4.png'
import NTF5 from '../Assets/home/nft5.png'
import NTF6 from '../Assets/home/nft6.png'
import NTF7 from '../Assets/home/nft7.png'

import { NavLink } from 'react-router-dom';

function Event(props){

    const explorerValues = [
        {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
        {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: 'Bundle of 5', pack: false},      
        {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false},      
        {img: NTF7, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
        {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
        {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
        {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false}
    ]

    return(
        <div className={props.darkMode ? "event_component dark" : "event_component"}>
            <NavLink to="gallery">{'< Events'}</NavLink>
            <div className={props.darkMode ? "event_block_wrapper dark": "event_block_wrapper"}>
              <div className="event_block">
                <div>
                  <img src={EventImg} alt="event_image" />
                </div>
              </div>
              <div className="event_info">
                <h2>NFT Crypto Comicon</h2>
                <span className="description">Description:</span>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                <div className="event_info_footer">
                  <span>
                    <img src={Calendar} alt="calendar" />
                    17.04.2021
                  </span>
                  <span>
                    <img src={User} alt="user" />
                    555
                  </span>
                </div>
                <button>Join</button>
              </div>
            </div>
            <div className="explorer">
                <div className="home_gallery" style={{ display: 'flex', flexWrap: 'wrap'}}>
                    <GalleryBlock nftBlocks={explorerValues} postNum={8} darkMode={props.darkMode} />
                </div>
            </div>            
        </div>
    )
}

export default Event;